import { ArrowRight, Sparkles } from "lucide-react";
import { useMemo } from "react";
import FlexxLogoImg from "../FlexxLogoImg";

const Hero = ({ onJoinClick }) => {
  // Generate floating particles
  const particles = useMemo(() => {
    return Array.from({ length: 20 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 80}%`,
      delay: `${Math.random() * 3}s`,
      duration: `${3 + Math.random() * 2}s`
    }));
  }, []);

  return (
    <section data-testid="hero-section" className="hero-section">
      {/* Background */}
      <div className="hero-bg-wrapper">
        <img 
          className="hero-bg-image" 
          src="https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=1920&q=80"
          alt="AI Trading Background"
        />
        <div className="hero-bg-overlay"></div>
        <div className="hero-bg-radial"></div>
      </div>

      {/* Floating Particles */}
      <div className="hero-particles">
        {particles.map(p => (
          <div 
            key={p.id}
            className="particle"
            style={{
              left: p.left,
              top: p.top,
              animationDelay: p.delay,
              animationDuration: p.duration
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="hero-content">
        {/* Badge */}
        <div className="hero-badge">
          <Sparkles className="hero-badge-icon" size={16} />
          <span className="hero-badge-text">AI-Powered Trading Education</span>
        </div>

        {/* Headlines */}
        <div className="hero-headline">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "-30px 0 -50px",
              gap: 0,
            }}
          >
            <FlexxLogoImg
              className="flexx-hero-logo"
              style={{ height: "clamp(180px, 28vw, 420px)" }}
            />
          </div>
          <p className="hero-title-sub">
            Structured Education for <span className="gold">AI-Powered Trading</span>
            <br />
            <span className="gold">& Web3</span>
          </p>
        </div>

        <p className="hero-subheadline">
          FLEXX Academy is an education and collaboration community focused on disciplined learning, 
          responsible trading frameworks, and readiness for modern AI-powered trading ecosystems and 
          digital asset technologies.
        </p>

        <div className="cta-group">
          <button 
            data-testid="join-community-btn" 
            className="btn-primary"
            onClick={onJoinClick}
          >
            <span>Join the Community</span>
            <ArrowRight className="btn-icon" size={16} />
          </button>
          <a href="#collaboration" data-testid="explore-collaboration-btn" className="btn-secondary">
            <span>Explore Collaboration</span>
            <ArrowRight className="btn-icon" size={16} />
          </a>
        </div>

        <p className="disclaimer">
          Education and collaboration only. No financial advice. No performance guarantees. No brokerage services.
        </p>
      </div>

      {/* Bottom Fade */}
      <div className="hero-bottom-fade"></div>
    </section>
  );
};

export default Hero;
